/**
 * Which payment methods a location may take on Receive Payments → New Sale.
 *
 * Driven by the two super-admin switches on the location (Credit / Debit Card,
 * ACH / Bank Account) that sit under the Receive Payments module gate. A
 * location that hasn't loaded yet, or a row from before the switches existed,
 * resolves to both ON — so the form never flashes locked tabs while loading
 * and nothing changes for a store until a super admin turns a method off.
 */
export interface ReceivePaymentMethodFlags {
  rpCardEnabled?: boolean | null;
  rpAchEnabled?: boolean | null;
}

export type ReceivePaymentMethodAvailability = { card: boolean; ach: boolean };

export function resolveReceivePaymentMethods(
  location: ReceivePaymentMethodFlags | null | undefined,
): ReceivePaymentMethodAvailability {
  return {
    card: location?.rpCardEnabled !== false,
    ach: location?.rpAchEnabled !== false,
  };
}
